export function trackRegisterClick(section: string, label?: string) {
  if (typeof window.gtag !== "function") return;

  window.gtag("event", "register_click", {
    section_source: section,
    click_label: label ?? "",
  });
}
